import _ from 'lodash'
import Vue from 'vue'
import { API } from '@/plugins/api'
import { hamiVuex } from '@/store/base'
import { projectStore } from '@/store/project'

export const productStore = hamiVuex.store({
  $name: 'product',
  $state: {
    productMap: {},
  },
  UPSET(product) {
    this.$patch(state => {
      if (_.isNil(product.equity_s)) {
        product.equity_s = state.productMap[product.id]?.equity_s ?? []
      }
      Vue.set(state.productMap, product.id, product)
    })
  },
  DELETE(id) {
    this.$patch(state => {
      Vue.delete(state.productMap, id)
    })
  },
  LOAD(product_s) {
    let map = {}
    _.forEach(product_s, product => {
      map[product.id] = product
    })
    this.$patch(state => {
      state.productMap = map
    })
  },
  _PROCESS_EQUITY(product_equity, handler) {
    this.$patch(state => {
      let product = state.productMap[product_equity.product_id]
      if (_.isNil(product)) {
        return
      }
      if (_.isNil(product.equity_s)) {
        Vue.set(product, 'equity_s', [])
      }
      let index = product.equity_s.findIndex(x => x.id === product_equity.id)
      handler(product.equity_s, index)
    })
  },
  UPSERT_EQUITY(product_equity) {
    this._PROCESS_EQUITY(product_equity, (equity_s, index) => {
      if (index >= 0) {
        Vue.set(equity_s, index, product_equity)
      } else {
        equity_s.push(product_equity)
      }
    })
  },
  DELETE_EQUITY(product_equity) {
    this._PROCESS_EQUITY(product_equity, (equity_s, index) => {
      if (index >= 0) {
        Vue.delete(equity_s, index)
      }
    })
  },
  get(id) {
    return this.productMap[id]
  },
  get list() {
    return _.reverse(
      _.sortBy(_.values(this.productMap), [
        item => {
          let ret = 0
          if (item.is_onsale) {
            ret += 2
          }
          if (item.is_redeem) {
            ret += 1
          }
          return ret
        },
        item => item.dt_created,
      ])
    )
  },
  doLoad: _.once(async function doLoad() {
    let payload = { project_id: projectStore.currentId, include_equity: true }
    let result = await API.call('merchant/product.query', payload)
    this.LOAD(result.item_s)
  }),
  async doCreate(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/product.create', payload)
    this.UPSET(result)
    return result
  },
  async doUpdate(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/product.update', payload)
    this.UPSET(result)
  },
  async doDelete(id) {
    await API.call('merchant/product.delete', { id: id })
    this.DELETE(id)
  },
  getEquity({ product_id, id }) {
    let product = this.get(product_id)
    let equity_s = product.equity_s || []
    return equity_s.find(x => x.id === id)
  },
  async doCreateEquity(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/product.create_equity', payload)
    this.UPSERT_EQUITY(result)
    return result
  },
  async doUpdateEquity(payload) {
    payload.project_id = projectStore.currentId
    let result = await API.call('merchant/product.update_equity', payload)
    this.UPSERT_EQUITY(result)
  },
  async doDeleteEquity({ id, product_id }) {
    let product_equity = this.getEquity({ id, product_id })
    if (!_.isNil(product_equity)) {
      await API.call('merchant/product.delete_equity', { id })
      this.DELETE_EQUITY(product_equity)
    }
  },
})
